import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'bra-mask',
  templateUrl: './bra-mask.component.html',
  styleUrls: ['./bra-mask.component.css']
})
export class BraMaskComponent implements OnInit {

  @Input()
  name: string;

  @Input()
  placeholder: string;

  @Input() value: any;
  @Output() valueChange = new EventEmitter();
  change(newValue) {
    this.value = newValue;
    this.valueChange.emit(newValue);
  }

  @Input()
  readonly: boolean;

  @Input()
  messageError: string;

  @Input()
  mask: string;

  mascara: any;

  constructor() { }

  ngOnInit() {
    if(this.mask == "TELEFONE"){
      this.mascara = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }
    else if(this.mask == "CEP"){
      this.mascara = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
    }
    else if(this.mask == "CPF"){
      this.mascara = [/\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/];
    }
    else if(this.mask == "CNPJ"){
     this.mascara = [
                      /[A-Z0-9]/,
                      /[A-Z0-9]/,
                      ".",
                      /[A-Z0-9]/,
                      /[A-Z0-9]/,
                      /[A-Z0-9]/,
                      ".",
                      /[A-Z0-9]/,
                      /[A-Z0-9]/,
                      /[A-Z0-9]/,
                      "/",
                      /[A-Z0-9]/,
                      /[A-Z0-9]/,
                      /[A-Z0-9]/,
                      /[A-Z0-9]/,
                      "-",
                      /\d/,
                      /\d/
                    ]
    }
    else if(this.mask == "DATA"){
      this.mascara = [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];
    }
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-mask/bra-mask.component.ts